module.exports = __webpack_public_path__ + "static/mortgageDS-f0c503888ce14a4e4f517864f3e95333.png";